export class ViewModelAtualizarConfig {
    icAtivo: string
    mensagem: string
}